import {Typography} from '@mui/material';
import {useState} from 'react';
import ArrDatePicker, {
  Condition,
} from '../../../components/common/arr-date-picker/ArrDatePicker';

const DatePicker = () => {
  const [dateValue, setDateValue] = useState<
    string | [] | [string | undefined, string | undefined]
  >('');
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [operators, setOperators] = useState<string[] | undefined>([]);
  const [condition, setCondition] = useState<Condition | undefined>();
  const handleChange = (
    value: string | [] | [string | undefined, string | undefined],
    operators: string[] | undefined,
    condition: Condition | undefined
  ) => {
    setDateValue(value);
    setOperators(operators);
    setCondition(condition);
  };

  const onRangeChange = (start: string, end: string) => {
    setStartDate(start);
    setEndDate(end);
  };
  return (
    <div>
      <Typography>{dateValue}</Typography>
      <Typography>
        {startDate} - {endDate}
      </Typography>

      <Typography>Range Date Picker</Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-range-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD-YYYY/MM/DD"
        onRangeChange={onRangeChange}
        applyEnable={true}
        initialStartDate="2022/02/02"
        initialEndDate="2022/02/04"
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Single Date Picker without Apply Button</Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD"
        onChange={handleChange}
        showToday={true}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Single Date Picker with Apply button </Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD HH:mm"
        onChange={handleChange}
        applyEnable={true}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Single Date Picker with clear icon </Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD"
        onChange={handleChange}
        applyEnable={true}
        shouldShowClearButton={true}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>Single Date Picker with Initial value , required </Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="date-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD"
        onChange={handleChange}
        applyEnable={true}
        initialStartDate="2022/02/02"
        required={true}
      />
      <br />
      <br />
      <br />
      <br />
      <Typography>query Date Picker</Typography>
      <Typography>{dateValue}</Typography>
      <Typography>{operators}</Typography>
      <Typography>{condition}</Typography>
      <ArrDatePicker
        dataTestId="demo-component"
        type="query-date-picker"
        label=" Date of Birth"
        placeholder="YYYY/MM/DD"
        onChange={handleChange}
        applyEnable={true}
      />
    </div>
  );
};

export default DatePicker;
